export default __webpack_public_path__ + "static/media/Souparnika.e9638d74.jpg";